import Axios from 'axios';
import { OrderCircle_CONFIG } from '@/js/config';
const RESOURCE_NAME = OrderCircle_CONFIG.API_URL + 'v1';
export default {  
  get(id) {
    return Axios.get(`${RESOURCE_NAME}/${id}`);
  }, 
  login(data) {
    return Axios.post(RESOURCE_NAME+'/login', data );
  },  
  adminLogin(data) {
    return Axios.post(RESOURCE_NAME+'/admin-login', data );
  },  
  brandSignup(data) {
    return Axios.post(RESOURCE_NAME+'/admin-signup', data );
  },  
  signup(data) {
    return Axios.post(RESOURCE_NAME+'/signup', data, {
      headers: {
        'Content-Type':'multipart/form-data'
      }
    } );
  },  
  getData() {
    return Axios.get(RESOURCE_NAME+'/getContext' );
  },  
  getProductsOnShop(pageNumber,pageSize,searchFilter,catFilter) {
    var pageURL;
        if(typeof pageNumber !== 'undefined'){  pageURL =`?page=`+pageNumber }
        if(typeof pageSize !== 'undefined'){  pageURL =pageURL+`&pageSize=`+pageSize }
        if(typeof searchFilter !== 'undefined'){  pageURL = pageURL + `&searchFilter=`+searchFilter }
        if(typeof catFilter !== 'undefined'){  pageURL = pageURL + `&catFilter=`+catFilter }
    return Axios.get(`${RESOURCE_NAME}`+ '/getProductsForShop' + pageURL);
  },  
  loadShopInputData(input) {
    return Axios.post(RESOURCE_NAME+'/getProductsForInputSearch',input );
  },  
  forgotPass(data) {
    return Axios.post(RESOURCE_NAME+'/forgotpassword', data );
  },
  resetPassword(data) {
    return Axios.post(RESOURCE_NAME+'/password/reset', data );
  },
  forgotUserName(data) {
    return Axios.post(RESOURCE_NAME+'/forgotUsername', data );
  },
  subdomainRemind(data) {
    return Axios.post(RESOURCE_NAME+'/postSubdomainRemind', data );
  },
  getFormFields(data) {
    return Axios.get(RESOURCE_NAME+'/getSignupFormFields');
  },
  getCurrency(data) {
    return Axios.get(RESOURCE_NAME+'/getStoreCurrencies');
  },
  getLogout(token) {
    return Axios.post(RESOURCE_NAME+'/logout');
  },
  impersonateToCustomer(token) {
    return Axios.post(RESOURCE_NAME+'/impersonate');
  },
  // don't remove headers because its getting from admin to brand
  impersonateToBrand(data) {
    return Axios.post(RESOURCE_NAME+'/impersonateToBrand',data,{headers: {'Authorization':'Bearer '+ data.token }});
  },
  backToBrandDashboard(data) {
    return Axios.post(RESOURCE_NAME+'/backToBrand',data);
  },
  changePassword(data) {
    return Axios.post(RESOURCE_NAME+'/change-password',data);
  },
  autoLogShopify(data) {
    return Axios.post(RESOURCE_NAME+'/shopifyAutoLogin',data);
  },
  getIntercomData() {
    return Axios.get(RESOURCE_NAME + '/intercom-data');
  },
  autoLogXero(data) {
    return Axios.post(RESOURCE_NAME+'/xeroAutoLogin',data);
  },
  autoLogin(data) {
    return Axios.post(RESOURCE_NAME+'/auto-login',data);
  },
};